(() => {
  const defaultCountryForm = document.getElementById('OleaDefaultCountry');
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form === defaultCountryForm || !form.querySelector('[name="form_type"][value="localization"]')) return;
    const country = new FormData(form).get('country_code');
    if (country) try { localStorage.setItem('olea:country-preference', String(country)); } catch {}
  }, true);
  if (defaultCountryForm) {
    try {
      const preference = localStorage.getItem('olea:country-preference');
      if (!preference) {
        localStorage.setItem('olea:country-preference', 'FR');
        if (document.documentElement.dataset.oleaCountry !== 'FR') defaultCountryForm.submit();
      }
    } catch {}
  }
  const selector = 'dialog.olea-approved-modal,dialog.olea-approved-sheet';
  let lastTrigger = null;
  document.addEventListener('pointerdown', (event) => {
    if (!event.target.closest('dialog[open]')) lastTrigger = event.target.closest('button,a,input,summary');
  }, { capture: true, passive: true });
  document.addEventListener('keydown', (event) => {
    if ((event.key === 'Enter' || event.key === ' ') && !event.target.closest('dialog[open]')) lastTrigger = document.activeElement;
  }, true);
  function enhance(dialog) {
    if (dialog.dataset.approvedEnhanced) return;
    dialog.dataset.approvedEnhanced = 'true';
    dialog.addEventListener('close', () => {
      if (document.querySelector('dialog[open]')) return;
      if (lastTrigger?.isConnected && (document.activeElement === document.body || document.activeElement === dialog)) lastTrigger.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog || !dialog.open) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) window.OleaOverlayMotion?.hide(dialog) ?? dialog.close();
    });
  }
  function scan(root) {
    if (root.matches?.(selector)) enhance(root);
    root.querySelectorAll?.(selector).forEach(enhance);
  }
  scan(document);
  new MutationObserver((mutations) => mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => { if (node.nodeType === 1) scan(node); }))).observe(document.body, { childList: true, subtree: true });
})();
